module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_7042.c54de35b.png";